import { useAppState } from 'hooks/useAppState';
import { User } from 'types/state';

export const useUser = (): null | User => {
  const { user } = useAppState();

  return user;
};
